/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectAzureVaultAccountRequest {
  /**
  * The tenant ID. This field is required. 
  */
  'tenantId': string;
  /**
  * The subscription ID. This field is required. 
  */
  'subscriptionId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return ConnectAzureVaultAccountRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

